const roomIdPattern =
  /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

export function capacityRoomId(input: string): string {
  const value = input.trim();
  if (roomIdPattern.test(value)) return value.toLowerCase();
  try {
    const url = new URL(value);
    const match = url.pathname.match(
      /^\/(?:platform\/room|share\/v2)\/([^/]+)\/?$/,
    );
    if (
      ['https:', 'http:'].includes(url.protocol) &&
      match &&
      roomIdPattern.test(match[1])
    ) {
      return match[1].toLowerCase();
    }
  } catch {}
  throw new Error('请输入有效的房间 ID 或房间链接');
}

export function capacityUserId(input: string): string {
  const value = input.trim();
  if (!/^[1-9][0-9]{0,19}$/.test(value))
    throw new Error('请输入有效的数字 UID');
  return value;
}
